<template>
  <div class="customer-components loader-container">
    <h2>Components</h2>
    <div class="actions loader-container">
      <input v-model="themeName" type="text" placeholder="e.g. Stark" /><button
        :disabled="!themeName"
        @click.prevent="addTheme"
      >
        Add New Theme
      </button>
    </div>
    <div class="actions loader-container">
      <select v-model="serverId">
        <option :value="null">&lt;Select Server&gt;</option>
        <option v-for="server in servers" v-bind:value="server.serverId">
          {{ server.serverName }}
        </option>
      </select>
      <select v-model="componentId" placeholder="Server">
        <option :value="null">&lt;Select Component&gt;</option>
        <option
          v-for="component in components"
          v-bind:value="component.componentId"
        >
          {{ component.componentName }}
        </option>
      </select>
      <button
        :disabled="!componentId || !serverId"
        @click.prevent="addCustomerComponent"
      >
        Add Component
      </button>
      <Loader :loading="addingComponent" />
    </div>
    <div class="table-wrapper loader-container">
      <vue-good-table
        :columns="[
          {
            label: 'Component',
            field: 'component.componentName'
          },
          {
            label: 'Server',
            field: 'server.serverName'
          },
          {
            label: 'Actions',
            field: 'actions'
          }
        ]"
        :rows="customerComponents"
      >
        <template slot="table-row" slot-scope="props">
          <button
            v-if="props.column.field == 'actions'"
            @click.prevent="deleteCustomerComponent(props.row.componentId)"
          >
            Delete
          </button>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template></vue-good-table
      >
      <Loader :loading="loadingCustomerComponents" />
    </div>
  </div>
</template>

<script>
import service from "@/services/service.js";
import Loader from "@/components/Loader.vue";
import { VueGoodTable } from "vue-good-table";
export default {
  components: { Loader, VueGoodTable },
  props: {
    customerId: { type: String, default: null }
  },
  data() {
    return {
      serverId: null,
      componentId: null,
      customerComponents: [],
      servers: [],
      components: [],
      loadingCustomerComponents: false,
      loadingServers: false,
      loadingComponents: false,
      componentName: null,
      addingComponent: false,
      themeName: null
    };
  },
  created() {
    this.getCustomerComponents();
    this.getServers();
    this.getComponents();
  },
  methods: {
    addTheme() {
      var self = this;
      self.addingComponent = true;
      service
        .addTheme(self.customerId, self.themeName)
        .then(() => {
          self.themeName = null;
          self.addingComponent = false;
          self.getCustomerComponents();
          self.getComponents();
        })
        .catch(() => {
          self.addingComponent = false;
        });
    },
    deleteCustomerComponent(componentId) {
      var self = this;
      service
        .deleteCustomerComponent(self.customerId, componentId)
        .then(() => {
          self.getCustomerComponents();
        })
        .catch(() => {});
    },
    addCustomerComponent() {
      var self = this;
      self.addingComponent = true;
      service
        .addCustomerComponent(self.customerId, self.serverId, self.componentId)
        .then(() => {
          self.componentName = null;
          self.addingComponent = false;
          self.getCustomerComponents();
        })
        .catch(() => {
          self.addingComponent = false;
        });
    },
    addComponent() {
      var self = this;
      self.addingComponent = true;
      service
        .addComponent(self.componentName)
        .then(() => {
          self.componentName = null;
          self.addingComponent = false;
          self.getCustomerComponents();
        })
        .catch(() => {
          self.addingComponent = false;
        });
    },
    getComponents() {
      var self = this;
      self.loadingComponents = true;
      service
        .getComponents()
        .then((response) => {
          self.components = response.data;
          self.loadingComponents = false;
        })
        .catch(() => {
          self.loadingComponents = false;
        });
    },
    getServers() {
      var self = this;
      self.loadingServers = true;
      service
        .getServers(self.customerId)
        .then((response) => {
          self.servers = response.data;
          self.loadingServers = false;
        })
        .catch(() => {
          self.loadingServers = false;
        });
    },
    getCustomerComponents() {
      var self = this;
      self.loadingCustomerComponents = true;
      service
        .getCustomerComponents(self.customerId)
        .then((response) => {
          self.customerComponents = response.data;
          self.loadingCustomerComponents = false;
        })
        .catch(() => {
          self.loadingCustomerComponents = false;
        });
    }
  }
};
</script>
